<template>
    <div>
        <el-container class="content">
            <el-aside v-show="isCollapse == false" class="aside" width="266px">
                <div class="box">
                    <div class="img">
                        <!-- <img :src="orgPhoto" alt="" /> -->
                        <img
                            src="../../assets/img/leftIcon/jcxx.png"
                            alt=""
                            style="width: 45px; height: auto"
                        />
                    </div>
                    <div class="txt">
                        <span>社区助餐管理系统</span>
                        <span>Helping meals System</span>
                    </div>
                </div>
                <el-row class="tac">
                    <el-col>
                        <el-menu
                            :default-active="$route.path"
                            background-color="#37404f"
                            text-color="#ffffff"
                            :unique-opened="true"
                            :router="true"
                        >
                            <menu-item
                                v-for="(item, index) in menuList"
                                :key="index"
                                :item="item"
                            ></menu-item>
                        </el-menu>
                    </el-col>
                </el-row>
            </el-aside>
            <el-container>
                <el-main>
                    <main-header @change="Showaside" />
                    <router-view v-if="isRouterAlive"></router-view>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import MainHeader from "@/components/MainHeader"
import menuItem from "@/components/menuItem"
export default {
    data() {
        return {
            menuList: [], //菜单列表
            // 按钮开关
            isCollapse: false,
            default_openeds_array: ["1"],
            isRouterAlive: true,
            orgPhoto: "",
        }
    },
    components: {
        MainHeader,
        menuItem,
    },
    provide() {
        //提供
        return {
            reload: this.reload,
        }
    },
    methods: {
        // 跳转
        gopage(pageName) {
            this.$router.push({ name: pageName })
        },
        // 隐藏侧边栏点击按钮事件
        Showaside() {
            this.isCollapse = !this.isCollapse
        },
        // -----------------------------------------------------
        // 侧边栏导航自动关闭处理事件
        handleSelect(key, keyPath) {
            if (key == "1") {
                this.currentView = "componnts"
            }
        },
        handleOpen(key) {
            this.default_openeds_array.push(key)
        },
        reload() {
            this.isRouterAlive = false
            this.$nextTick(function () {
                this.isRouterAlive = true
            })
        },
    },
    created() {
        let menuData = this.$store.state.menu
        let [{ children = [] }] = menuData.filter(
            (item) => item.menuType == 1 && item.title == "社区养老"
        )
        let temp = children.filter(
            (item) => item.menuType == 2 && item.title == "就餐信息"
        )
        this.menuList = temp[0].children
        // this.menuList = elderManage.children;
        this.orgPhoto = this.$store.state.info.orgPhoto
    },
}
</script>
<style lang="less" scoped>
@import "./assets/iconfont/iconfont.css";
html,
body {
    ::-webkit-scrollbar {
        width: 0 !important;
    }
    ::-webkit-scrollbar {
        width: 0 !important;
        height: 0;
    }
    /deep/ .table_checkbox {
        .el-checkbox-group {
            display: flex;
            flex-direction: column;
        }
    }
}
/deep/ .elderManage_container {
    padding: 20px 20px 42px 20px !important;
    background-color: #ffffff !important;
    &.active {
        padding: 0 !important;
    }
    .table_title {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        .btn_group {
            margin-top: 42px;
        }
    }
    // table_add_wraoper
    /deep/ .dialog_container {
        .el-dialog__header {
            border-bottom: 1px solid #e5e5e5;
        }
        .el-dialog__body {
            padding-left: 60px;
            padding-right: 60px;
        }
        .dialog_content {
            .el-col {
                text-align: center;
            }
            .el-select {
                .el-input__inner {
                    width: 100%;
                }
            }
            .table_add_wraoper {
                .add_table {
                    margin-top: 24px;
                }
            }
        }
        .el-dialog__footer {
            background: #f5f5f5;
            padding: 8px 15px;
            border-top: 1px solid #e5e5e5;
            border-bottom-left-radius: 5px;
            border-bottom-right-radius: 5px;
        }
    }
    .table_container {
        margin-top: 12px;
    }
    .pagination_container {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }
}
.content {
    height: 100vh;
    text-align: left;
    .aside {
        height: 100vh;
        background-color: #37404f;
        transition: 0.3s;
        .box {
            margin: 10px 0;
            display: flex;
            display: -webkit-flex;
            flex-direction: row;
            .img {
                margin-left: 20px;
                width: 43px;
                height: 100%;
                display: inline-block;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .txt {
                margin-left: 10px;
                line-height: 25px;
                color: #ffffff;

                span:nth-child(1) {
                    font-size: 18px;
                    display: block;
                }
                span:nth-child(2) {
                    display: block;
                    font-size: 12px;
                }
            }
        }
        /deep/ .tac {
            // display: flex;
            width: 100%;
            span {
                font-size: 13px;
                color: #ffffff;
            }
            .el-menu {
                border-right: unset;
            }
            .el-menu-item .el-submenu__title {
                width: 100%;
                height: 52px;
            }
            .el-submenu .el-menu-item {
                padding: 0;
                height: 52px;
                min-width: 100%;
            }
            .el-submenu__title {
                // padding-right: 10px;
                font-size: 13px;
            }
            .el-menu-item.is-active,
            .el-submenu__title:hover {
                background: #437ae1 !important;
                color: #fff !important;
            }
            .el-menu-item {
                color: #ffffff;
                // padding-left: 30px !important;
            }

            .el-menu-item:hover {
                background: #437ae1 !important;
                color: #fff !important;
            }
        }
    }
    .el-main {
        padding: 0;
        background-color: rgba(242, 242, 242, 1);
    }
    .el-icon-s-fold {
        color: #ffffff;
    }
    .el-icon-caret-right {
        color: #ffffff;
    }
    /deep/ .el-icon-arrow-down:before {
        // color: #fff;
        // font-size: 18px;
        content: "\E6DF";
        font-weight: bold;
    }
    /deep/ .el-submenu__title /deep/ .el-menu-item {
        padding-left: 10px !important;
    }
}
</style>